export default {
    name: 'calendar_reservation',
    definition: {
        description: '',
        start: '',
        end: '',
        employees: [],
        location_id: '',
        color_location: '',
    },
    options: {
        collectionPath: 'calendar_items',
    },
};
